import React from 'react';

const Coin = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31 31">
        <g fill="currentColor" fillRule="nonzero">
            <path d="M15.5 0C6.94 0 0 6.94 0 15.5 0 24.06 6.94 31 15.5 31 24.06 31 31 24.06 31 15.5A15.5 15.5 0 0 0 15.5 0Zm0 27.9c-6.848 0-12.4-5.552-12.4-12.4 0-6.848 5.552-12.4 12.4-12.4 6.848 0 12.4 5.552 12.4 12.4a12.4 12.4 0 0 1-12.4 12.4Z" />
            <path d="M18.691 12.374h3.191c0-2.22-2.01-4.017-4.786-4.533v-1.72c0-.862-.715-1.562-1.596-1.562-.881 0-1.596.7-1.596 1.563v1.72c-2.776.515-4.786 2.312-4.786 4.532s2.01 4.017 4.786 4.533v3.048c-1.005-.329-1.595-.891-1.595-1.329H9.118c0 2.22 2.01 4.017 4.786 4.533v1.72c0 .862.715 1.562 1.596 1.562.881 0 1.596-.7 1.596-1.563v-1.72c2.776-.515 4.786-2.312 4.786-4.532s-2.01-4.017-4.786-4.533v-3.048c1.005.329 1.595.891 1.595 1.329Zm-6.382 0c0-.438.59-1 1.595-1.329v2.658c-1.005-.329-1.595-.891-1.595-1.33Zm6.382 6.252c0 .438-.59 1-1.595 1.329v-2.658c1.005.329 1.595.891 1.595 1.33Z" />
        </g>
    </svg>
);

export default Coin;
